<template>
  <modal
    :title="$t('title')"
    @hidden="onHidden"
    class="product-category-assignment-form"
    playground
    ref="modal"
  >
    <form @submit.prevent="submit">
      <div class="uk-modal-body">
        <validation-alert-box :errors="fields.errors.base" />

        <tenant-combobox
          :disabled="!isEditable"
          :label="$t('fields.tenant')"
          :value="fields.values.tenant"
          @change="fields.change.tenant"
          v-if="!values"
        />

        <product-category-combobox
          :disabled="!isEditable"
          :errors="fields.errors.category"
          :filter="productCategoryComboboxFilter"
          :label="$t('fields.category')"
          :value="fields.values.category"
          @change="fields.change.category"
          v-if="tenant"
        />
      </div>

      <div class="uk-modal-footer uk-text-right">
        <submit-button :disabled="!isSubmittable" type="primary" />
        <common-button @click="hide">{{$t('actions.cancel')}}</common-button>
      </div>
    </form>
  </modal>
</template>

<script>
import CancelButton from '@/components/CancelButton';
import CommonButton from '@/components/CommonButton';
import Form from '@/mixins/Form';
import Modal from '@/components/Modal';
import ProductCategoryCombobox from '@/components/ProductCategoryCombobox';
import RadioGroupInput from '@/components/RadioGroupInput';
import SubmitButton from '@/components/SubmitButton';
import TenantCombobox from '@/components/TenantCombobox';
import TextInput from '@/components/TextInput';
import ValidationAlertBox from '@/components/ValidationAlertBox';

export default {
  name: 'product-category-assignment-form',
  mixins: [
    Form({
      tenant: {
        loadErrorsFrom: false,
        required: true,
        dumpTo: false,
      },
      category: {
        loadErrorsFrom: false,
        required: true,
        validate: [
          function validateProductCategoryNotExists(value) {
            const isValid = !this.productCategories
              .find(p => p.id === value.id);

            return {
              isValid,
              message: this.$t('validationErrors.productCategoryTaken'),
            };
          },
        ],
      },
    }),
  ],
  components: {
    CancelButton,
    CommonButton,
    Modal,
    ProductCategoryCombobox,
    RadioGroupInput,
    SubmitButton,
    TenantCombobox,
    TextInput,
    ValidationAlertBox,
  },
  props: {
    productCategories: Array,
  },
  computed: {
    tenant() {
      if (this.values && this.values.category) {
        return this.values.category.tenant;
      }
      return this.fields.values.tenant;
    },
    tenantId() {
      if (!this.tenant) return null;
      return this.tenant.id;
    },
    selectedProductCategoryIds() {
      if (!this.productCategories) return [];
      return this.productCategories.map(c => c.id);
    },
    productCategoryComboboxFilter() {
      return {
        tenantId: this.tenantId,
        omittedIds: this.selectedProductCategoryIds,
      };
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onHidden() {
      this.resetToDefaults();
      this.$emit('hidden');
    },
    resetToDefaults() {
      this.fields.values.tenant = null;
      this.fields.values.category = null;
      this.fields.errors.category = [];
    },
  },
  i18n: {
    messages: {
      de: {
        title: 'Produktkategorie verwalten',
        validationErrors: {
          productCategoryTaken:
            'Die Kategorie ist dieser Produktfamilie bereits zugeordnet',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductCategoryAssignmentForm.vue?92ab3d74